import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import { initVkBridgeIfMiniApp } from './lib/vk-mini-app';
import './i18n'; // Инициализация i18n
import './index.css';

/**
 * Entry point приложения
 * @contract Bootstrap React с i18n поддержкой и VK Mini App init
 */
initVkBridgeIfMiniApp();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
